export default __webpack_public_path__ + "static/media/idea.156285f0.svg";